/* istanbul ignore file */
export * from './WishlistButtonWithApi';
